























import Vue from 'vue';
import Component from 'vue-class-component';
import { IStartPage } from '@app/componentlib/src/common/types/JobMatchTypes';
import AccordionWithTitleDescription from '../../components/AccordionWithTitleDescription.vue';

@Component<StartPage>({
  components: {
    AccordionWithTitleDescription,
  },
  props: {
    content: Object,
    title: String,
  },
})
export default class StartPage extends Vue {
  /**
   * Props variables
   */
  content: IStartPage | undefined;
  title: string | undefined;

  /**
   * Component state variables
   */
  imageWave = require('@app/componentlib/src/assets/wave-bottom.svg');
  nettedLines = require('@app/componentlib/src/assets/netted-lines.svg');
  nettedLines2 = require('@app/componentlib/src/assets/netted-lines-2.svg');
  nettedLinesNew = require('@app/componentlib/src/assets/nettedLinesNew.svg');
  jumpToStepFromStorage: string = sessionStorage.getItem('stepToJumpTo') || '';
  showPage: boolean = false;

  /**
   * Lifecycle
   */
  mounted() {
    if (
      this.jumpToStepFromStorage !== 'undefined' &&
      this.jumpToStepFromStorage !== '' &&
      this.jumpToStepFromStorage !== undefined
    )
      window.location.replace(
        this.content?.buttonLink + '?jumpToStep=' + this.jumpToStepFromStorage
      );
    else this.showPage = true;
  }

  /**
   * Getters
   */

  /**
   * Methods
   */
}
